/* Lead Management endpoints (all tenant-scoped; see docs/API_CONTRACT.md).
   GET    /api/leads                       -> Lead[]
   GET    /api/leads/:id                   -> Lead & { timeline: {at,event}[] }
   POST   /api/leads                       -> Lead
   PATCH  /api/leads/:id                   -> Lead   (status changes append a timeline entry server-side)
   DELETE /api/leads/:id                   -> Lead
   GET    /api/leads/webhooks/deliveries   -> Delivery[]
   Visitor-chat lead capture goes through POST /api/widget/:conversationId/lead and lands in the same store. */
import { apiClient } from '../../api/apiClient'

export const STATUSES = ['New', 'Contacted', 'Qualified', 'Won', 'Lost']

const send = (url, method, body) => apiClient(url, { method, body: body === undefined ? undefined : JSON.stringify(body) }).then((res) => res.data)

export const getLeads = () => apiClient('/api/leads').then((res) => res.data)
export const getLead = (id) => apiClient(`/api/leads/${id}`).then((res) => res.data).catch((error) => { if (error.status === 404) return null; throw error })
export const createLead = (payload) => send('/api/leads', 'POST', payload)
export const updateLead = (id, patch) => send(`/api/leads/${id}`, 'PATCH', patch)
export const deleteLead = (id) => send(`/api/leads/${id}`, 'DELETE')
export const updateLeadStatus = (id, status) => updateLead(id, { status })
export const getWebhookDeliveries = () => apiClient('/api/leads/webhooks/deliveries').then((res) => res.data)

// CSV is built client-side from the rows currently shown (filters respected).
export async function exportLeadsCsv(rows) {
  if (!rows.length) return null
  const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`
  const head = ['ID', 'Name', 'Email', 'Phone', 'Source', 'Intent', 'Status', 'Score', 'Created'].map(escape).join(',')
  return [head, ...rows.map((lead) => [lead.id, lead.name, lead.email, lead.phone, lead.source, lead.intent, lead.status, lead.score, lead.createdAt].map(escape).join(','))].join('\r\n')
}
